import React from 'react';
import Meal1 from './Meal1';

import Footer from './Footer';




const About = () => {
    return (
        <div>
            <Meal1 />

            <Footer />



        </div>
    );
};

export default About;